import axios from 'axios';
import { GET_BEFORE_DAY_ORDER_TYPES, GET_ERRORS } from './types';

export const getBeforeDayOrderTypes = () => dispatch => {
  axios
    .get(`${process.env.REACT_APP_API_URL}/api/before_day_order_types`)
    .then(res => {
      dispatch({
        type: GET_BEFORE_DAY_ORDER_TYPES,
        payload: res.data,
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};
